import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./Button";
export function EmptyState({ motivo, semDados, filtroVazio = "Nenhum resultado para os filtros aplicados.", preCondicao, onLimpar, }) {
    if (motivo === null)
        return null;
    const texto = motivo === "sem-dados" ? semDados
        : motivo === "filtro-vazio" ? filtroVazio
            : preCondicao;
    return (_jsxs("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }, children: [_jsx("span", { children: texto }), motivo === "filtro-vazio" && onLimpar ? (_jsx(Button, { size: "sm", variant: "ghost", onClick: onLimpar, children: "\u2715 Limpar filtros" })) : null] }));
}
//# sourceMappingURL=EmptyState.js.map